"use strict";
// NOTE:
// in the future, all cause areas will be set to the parent-level NTEE code that the
// nonprofit uses in their tax filings.
// The original cause list is Causes and will be phased out by moving to
// CombinedCauses, and eventually to NTEECauses
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombinedCauses = exports.NTEECauses = exports.Causes = void 0;
exports.Causes = [
    "Animals",
    "Arts",
    "Civil/Human Rights",
    "Education",
    "Environment",
    "Health",
    "Housing",
    "Human Services",
    "Hunger",
];
exports.NTEECauses = [
    "Arts and culture",
    "Education",
    "Environment",
    "Philanthropy",
    "Health",
    "Science",
    "Social sciences",
    "Information and communications",
    "Public safety",
    "Public affairs",
    "Agriculture, fishing and forestry",
    "Community and economic development",
    "Religion",
    "Sports and recreation",
    "Human rights",
    "Human services",
    "International relations",
];
exports.CombinedCauses = [
    "Agriculture, fishing and forestry",
    "Animals",
    "Arts",
    "Arts and culture",
    "Civil/Human Rights",
    "Community and economic development",
    "Education",
    "Environment",
    "Health",
    "Housing",
    "Human rights",
    "Human services",
    "Human Services",
    "Hunger",
    "Information and communications",
    "International relations",
    "Philanthropy",
    "Public affairs",
    "Public safety",
    "Religion",
    "Science",
    "Social sciences",
    "Sports and recreation",
];
//# sourceMappingURL=data:application/json;base64,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